import './shared/ui/tokens.css';
import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';
import { mockTelegram } from '@/shared/lib/devMock';
import { setGuest } from '@/shared/lib/guest';
import { setupTelegram } from '@/shared/lib/telegram';

// Разработка вне Telegram: окружение подменяется до init SDK, иначе
// retrieveLaunchParams не найдёт параметров и приложение уйдёт в заглушку.
// В production ветка вырезается при сборке — import.meta.env.DEV = false.
if (import.meta.env.DEV && import.meta.env.VITE_DEV_INIT_DATA) {
  mockTelegram(
    import.meta.env.VITE_DEV_INIT_DATA,
    import.meta.env.VITE_DEV_APPEARANCE === 'light' ? 'light' : 'dark',
  );
}

setGuest(!setupTelegram());

const container = document.getElementById('root');
if (!container) {
  throw new Error('Элемент #root не найден');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
